export default __webpack_public_path__ + "static/media/Classwin-Time-blue.c028d201.svg";